/** Sample files of the upload step, generated in memory (no network). */
export const SAMPLE_FILES = Object.freeze({ ROSTER: 'roster', MANY_COLUMNS: 'many-columns' });

const ROSTER_COLUMNS = [
  'Employee ID',
  'First name',
  'Last name',
  'Email',
  'Job title',
  'Phone',
  'Location',
  'Role',
  'Groups',
];
const ROSTER_SIZE = 123;
const FIRST_NAMES = ['Ana', 'Luis', 'Marta', 'Diego', 'Sofia', 'Pablo', 'Elena', 'Jorge', 'Lucia', 'Mateo'];
const LAST_NAMES = ['Lopez', 'Garcia', 'Martin', 'Ruiz', 'Vega', 'Soto', 'Navarro', 'Rojas', 'Diaz', 'Cruz'];
const JOB_TITLES = ['Data Analyst', 'Product Manager', 'Engineer', 'Compliance Associate', 'Support Lead'];
const LOCATIONS = ['Bogota', 'Madrid', 'Mexico City', 'Miami'];
const ROLES = ['Developer', 'Viewer', 'Agent Builder', '', ''];
const GROUPS = ['Engineering', 'Data Team', 'AI Ops; Data Team', '', ''];
// Rows that exercise the review step: already a member, an invalid email, and a missing email.
const SPECIAL_EMAILS = { 4: 'carlos.rivera@avance.com', 9: 'chloe.adams@avance.com', 15: 'not-an-email', 21: '' };

const quote = (cell) => (/[",\n\r]/.test(cell) ? `"${cell.replace(/"/g, '""')}"` : cell);
const toCsv = (rows) => rows.map((cells) => cells.map(quote).join(',')).join('\r\n');

const pick = (list, index) => list[index % list.length];

function rosterRow(index) {
  const first = pick(FIRST_NAMES, index);
  const last = pick(LAST_NAMES, Math.floor(index / 3) + index);
  const generated = `${first}.${last}.${index}@avance.com`.toLowerCase();
  return [
    `EMP-${String(1000 + index)}`,
    first,
    last,
    index in SPECIAL_EMAILS ? SPECIAL_EMAILS[index] : generated,
    pick(JOB_TITLES, index),
    `+57 300 ${String(1000000 + index * 37).slice(0, 7)}`,
    pick(LOCATIONS, index),
    pick(ROLES, index),
    pick(GROUPS, index),
  ];
}

function rosterCsv() {
  const people = Array.from({ length: ROSTER_SIZE }, (_, index) => rosterRow(index));
  return toCsv([['Avance Financial roster'], ['Exported from the HR system'], ROSTER_COLUMNS, ...people]);
}

function manyColumnsCsv() {
  const extra = Array.from({ length: 22 }, (_, i) => `Custom field ${i + 1}`);
  const header = ['First name', 'Last name', 'Email', 'Job title', 'Role', 'Group', ...extra];
  const rows = Array.from({ length: 40 }, (_, index) => [
    pick(FIRST_NAMES, index),
    pick(LAST_NAMES, index + 2),
    `wide.${index}@avance.com`,
    pick(JOB_TITLES, index),
    pick(ROLES, index),
    pick(GROUPS, index),
    ...extra.map((_, i) => `value ${i + 1}`),
  ]);
  return toCsv([header, ...rows]);
}

const BUILDERS = {
  [SAMPLE_FILES.ROSTER]: { name: 'roster_avance.csv', build: rosterCsv },
  [SAMPLE_FILES.MANY_COLUMNS]: { name: 'roster_many_columns.csv', build: manyColumnsCsv },
};

/**
 * A sample spreadsheet as a `File`, ready to go through the same path as a picked file.
 *
 * @param {'roster'|'many-columns'} kind
 * @returns {File}
 */
export function buildSampleFile(kind) {
  const { name, build } = BUILDERS[kind] ?? BUILDERS[SAMPLE_FILES.ROSTER];
  return new File([build()], name, { type: 'text/csv' });
}
